/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import { SidebarGlobal } from "./_Sidebar";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import AppActions from "./AppActions";
import Icon from "./Icon";

class ProductView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                isConservativeCare: this.props.params.tab === 'conservative-care'
            },
            saving: false
        };
        if (this.props.params.id) {
            this.state.loading = true;
        }

        this.submit = this.submit.bind(this);

    }

    async componentDidMount() {
        this.fillList('/api/manufacturer/list', 'manufacturers', true);
        if (this.props.params.id) {
            qreq.get('/api/product/get/' + this.props.params.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
        await this.getSettings();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    submit(e) {
        e.preventDefault();

        var psize = this.state.item.productSize;

        if (psize) {
            psize = psize.trim().toLowerCase();
            if (psize.indexOf('x') < 0) {
                this.alert('The product size is invalid.');
                return;
            }
            try {
                var p = psize.split('x');
                var w = Number(p[0]);
                var l = Number(p[1]);

                if (w > l) {
                    this.alert('Width can not be larger than length.');
                    return;
                }
            }
            catch {
                this.alert('Failed to parse the product size.');
                return;
            }
        }

        let item = { ...this.state.item };

        if (this.state.MODEL !== 'WMS' && this.state.MODEL !== 'MNF') {
            item.productSize = '1x1';
        }

        this.setState({ item: item, saving: true });

        qreq.post('/api/product/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1>Edit Product</h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-primary" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> Save</button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Edit Product {this.state.item.isConservativeCare ? <small className="d-block">Conservative Care</small> : ''}</h1>
                <Breadcrumb path={[['Products', '/product/list' + (this.state.item.isConservativeCare ? '/conservative-care' : '')], ['Edit']]} />

                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg">
                        <Icon icon="faSave" /> Save
                    </button>
                </AppActions>

                <Card title="Info">
                    <div className="row row-cols-2">
                        <div className="col">
                            <FormInput model={this.state.item} name="productName" label="Product Name" type="text" required />
                        </div>
                        <div className="col">
                            <FormInput model={this.state.item} name="manufacturerID" label="Manufacturer" type="select" options={this.state.manufacturers ?? []} required />
                        </div>
                    </div>
                    <div className="row row-cols-2">
                        {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && <div className="col">
                            <FormInput model={this.state.item} name="productSize" label="Product Size (LxW)" type="text" required placeholder="0x0" />
                        </div>}
                        <div className="col">
                            <FormInput model={this.state.item} name="catalogCode" label="Catalog Code" type="text" />
                        </div>
                    </div>
                    <FormInput model={this.state.item} name="qCode" label="QCode" type="text" disabled={this.state.item.qCode && this.state.item.id} inputGroupClassName="mb-1" />
                    {this.state.item.qCode && this.state.item.id && <div className="text-muted mb-3">QCode can not be changed once set.</div>}
                    {!this.state.item.isConservativeCare ?
                        <div className="row row-cols-2">
                            <div className="col">
                                <FormInput model={this.state.item} name="price" label="Default Price per cm2" type="number" step="0.01" placeholder="0.00" />
                            </div>
                            <div className="col">
                                <FormInput model={this.state.item} name="cogs" label="COGS" type="number" step="0.01" placeholder="0.00" />
                            </div>
                        </div> : ''}
                </Card>
                <Card title="Alarms">
                    <div className="row">
                        <div className="col-md-3">
                            <FormInput model={this.state.item}
                                name="lowStockAlarm"
                                label="Low Stock Alarm"
                                type="switch"
                                onChange={this.change}
                            />
                        </div>
                        {this.state.item.lowStockAlarm && <>
                            <div className="col-md-3">
                                <FormInput model={this.state.item}
                                    name="lowStockAlarmThresh"
                                    label="Low Stock Alarm Threshold"
                                    type="number"
                                    step="1"
                                    onChange={this.change}
                                    placeholder="0"
                                    required
                                />
                            </div>
                            <div className="col-md-3">
                                <FormInput model={this.state.item}
                                    name="lowStockAlarmNotify"
                                    label="Email Notification"
                                    type="switch"
                                    onChange={this.change}
                                />
                            </div>
                        </>}
                    </div>


                </Card>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>

                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block">Save</button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}>Cancel and Go Back</button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(ProductView);